import React, { useEffect } from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Homepage from "./components/Homepage";
import Builder from "./components/Builder";
import Gallery from "./components/Gallery";
import Distilleria from "./components/Distilleria";
import PremiumCollections from "./components/PremiumCollections";
import CollectionDetail from "./components/CollectionDetail";
import Cart from "./components/Cart";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import BuonoRegalo from "./components/BuonoRegalo";
import ProfitCalculator from "./components/ProfitCalculator";
import LoginForm from "./components/Auth/LoginForm";
import PrivateRegisterForm from "./components/Auth/PrivateRegisterForm";
import BusinessRegisterForm from "./components/Auth/BusinessRegisterForm";
import RegisterChoice from "./components/Auth/RegisterChoice";
import Dashboard from "./components/Dashboard";
import Checkout from "./components/Checkout";
import OrderConfirmation from "./components/OrderConfirmation";
import QuoteConfirmation from "./components/QuoteConfirmation";
import OrderDetails from "./components/OrderDetails";
import TermsAndConditions from "./components/TermsAndConditions";
import QuoteAcceptancePage from "./components/QuoteAcceptancePage";
import PrivacyPolicy from "./components/PrivacyPolicy";
import AdminLogin from "./components/Admin/AdminLogin";
import AdminDashboard from "./components/Admin/AdminDashboard";
import AdminOrders from "./components/Admin/AdminOrders";
import AdminUsers from "./components/Admin/AdminUsers";
import UserDetail from "./components/Admin/UserDetail";
import AdminProducts from "./components/Admin/AdminProducts";
import AdminIngredients from "./components/Admin/AdminIngredients";
import AdminBottles from "./components/Admin/AdminBottles";
import AdminNewsletter from "./components/Admin/AdminNewsletter";
import GlobalDiscountSettings from "./components/Admin/GlobalDiscountSettings";
import AdminCollections from "./components/Admin/AdminCollections";
import AdminLabels from "./components/Admin/AdminLabels";
import AdminCanvaTemplates from "./components/Admin/AdminCanvaTemplates";
import AdminGallery from "./components/Admin/AdminGallery";
import AdminSettings from "./components/Admin/AdminSettings";
import AdminFormats from "./components/Admin/AdminFormats";
import AdminDiscountTiers from "./components/Admin/AdminDiscountTiers";
import AdminShippingCosts from "./components/Admin/AdminShippingCosts";
import AdminCoupons from "./components/Admin/AdminCoupons";
import AdminQuotes from "./components/Admin/AdminQuotes";
import QuoteDetail from "./components/Admin/QuoteDetail";
import AdminCustomers from "./components/Admin/AdminCustomers";
import AdminCrmFunnel from "./components/Admin/AdminCrmFunnel";
import AdminCrmTemplates from "./components/Admin/AdminCrmTemplates";
import AdminLandingLeads from "./components/Admin/AdminLandingLeads";
import AdminLeadCategories from "./components/Admin/AdminLeadCategories";
import AdminAgents from "./components/Admin/AdminAgents";
import CustomerDetail from "./components/Admin/CustomerDetail";
import OrderDetail from "./components/Admin/OrderDetail";
import CanvaTemplatesPage from "./components/CanvaTemplatesPage";
import ProtectedAdminRoute from "./components/Admin/ProtectedAdminRoute";
import ProtectedRoute from "./components/ProtectedRoute";
import LandingPage from "./components/LandingPage";
import WhatsAppFloat from "./components/WhatsAppFloat";
import StripeCheckout from "./components/StripeCheckout";
import PaymentSuccess from "./components/PaymentSuccess";
import PaymentCancelled from "./components/PaymentCancelled";
import HaiUnProgetto from "./components/HaiUnProgetto";
import CookieConsent from "./components/CookieConsent";
import Collections from "./components/Collections";
import Spedizioni from "./components/Spedizioni";
import ListinoWrapper from "./components/ListinoWrapper";
import ScrollToTop from "./components/ScrollToTop";
import TestLabelDesigner from "./components/TestLabelDesigner";
import Blog from "./components/Blog";
import BlogArticle from "./components/BlogArticle";
import AdminBlog from "./components/Admin/AdminBlog";
import AdminDigitalServices from "./components/Admin/AdminDigitalServices";
import FiereForm from "./components/FiereForm";
import LeadQualificationPage from "./components/LeadQualificationPage";
import { AuthProvider } from "./contexts/AuthContext";
import { AdminAuthProvider } from "./contexts/AdminAuthContext";
import { AgentAuthProvider } from "./contexts/AgentAuthContext";
import AgentLogin from "./components/Agent/AgentLogin";
import AgentDashboard from "./components/Agent/AgentDashboard";
import AgentCustomers from "./components/Agent/AgentCustomers";
import AgentQuotes from "./components/Agent/AgentQuotes";
import AgentQuoteNew from "./components/Agent/AgentQuoteNew";
import AgentSamples from "./components/Agent/AgentSamples";
import AdminPaymentMethods from "./components/Admin/AdminPaymentMethods";
import AdminSampleOrders from "./components/Admin/AdminSampleOrders";
import AgentOrders from "./components/Agent/AgentOrders";
import AgentCommissions from "./components/Agent/AgentCommissions";
import AgentGraphicRequests from "./components/Agent/AgentGraphicRequests";
import AgentSignup from "./components/AgentSignup";
import AdminGraphicRequests from "./components/Admin/AdminGraphicRequests";
import AgentListino from "./components/Agent/AgentListino";
import AgentProfitCalculator from "./components/Agent/AgentProfitCalculator";
import AdminCommissions from "./components/Admin/AdminCommissions";
import AdminLeadsImport from "./components/Admin/AdminLeadsImport";
import AdminReports from "./components/Admin/AdminReports";
import AdminLeads2Page from "./components/Admin/AdminLeads2Page";
import AdminLead2DetailPage from "./components/Admin/AdminLead2DetailPage";
import AdminLeads2TodoPage from "./components/Admin/AdminLeads2TodoPage";
import AgentLeads2Page from "./components/Agent/AgentLeads2Page";
import AgentLeads2TodoPage from "./components/Agent/AgentLeads2TodoPage";
import AgentLead2DetailPage from "./components/Agent/AgentLead2DetailPage";
import { Toaster } from "./components/ui/toaster";

function App() {
  // Unregister any existing service workers to prevent caching issues
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      // Unregister all service workers
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => {
          registration.unregister();
          console.log('Service Worker unregistered:', registration);
        });
      });
      
      // Clear all caches
      if ('caches' in window) {
        caches.keys().then((cacheNames) => {
          cacheNames.forEach((cacheName) => {
            caches.delete(cacheName);
            console.log('Cache deleted:', cacheName);
          });
        });
      }
      
      console.log('✅ Service Worker disabled - No more caching issues!');
    }
  }, []);

  return (
    <HelmetProvider>
      <AuthProvider>
        <AdminAuthProvider>
        <AgentAuthProvider>
        <div className="App">
          <ScrollToTop />
          <Routes>
              <Route path="/" element={<Homepage />} />
              <Route path="/servizi" element={<LandingPage />} />
              <Route path="/servizio-private-label" element={<LandingPage />} />
              <Route path="/builder" element={<Builder />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/distilleria" element={<Distilleria />} />
              <Route path="/carrello" element={<Cart />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/hai-un-progetto" element={<HaiUnProgetto />} />
              <Route path="/campioni" element={<Collections />} />
              <Route path="/campioni/:slug" element={<Collections />} />
              <Route path="/contatti" element={<Contact />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogArticle />} />
              <Route path="/fiere" element={<FiereForm />} />
              <Route path="/preventivo" element={<LeadQualificationPage />} />
              <Route path="/diventa-agente" element={<AgentSignup />} />
              <Route path="/calcolatore-guadagni" element={<ProfitCalculator />} />
              <Route path="/modelli-etichette" element={<CanvaTemplatesPage />} />
              <Route path="/spedizioni" element={<Spedizioni />} />
              <Route path="/listino" element={<ListinoWrapper />} />
              <Route path="/test-label-designer" element={<TestLabelDesigner />} />
              <Route path="/buono-regalo" element={<BuonoRegalo />} />
              <Route path="/login" element={<LoginForm />} />
              <Route path="/register" element={<RegisterChoice />} />
              <Route path="/register/private" element={<PrivateRegisterForm />} />
              <Route path="/register/business" element={<BusinessRegisterForm />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/order-confirmation/:orderNumber" element={<OrderConfirmation />} />
              <Route path="/quote-confirmation/:quoteNumber" element={<QuoteConfirmation />} />
              <Route path="/order-details/:orderNumber" element={<OrderDetails />} />
              <Route path="/pagamento" element={<StripeCheckout />} />
              <Route path="/payment-success" element={<PaymentSuccess />} />
              <Route path="/payment-cancelled" element={<PaymentCancelled />} />
              <Route path="/termini" element={<TermsAndConditions />} />
              <Route path="/accetta-preventivo/:token" element={<QuoteAcceptancePage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              
              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={
                <ProtectedAdminRoute>
                  <AdminDashboard />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/orders" element={
                <ProtectedAdminRoute>
                  <AdminOrders />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/reports" element={
                <ProtectedAdminRoute>
                  <AdminReports />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/leads2" element={
                <ProtectedAdminRoute>
                  <AdminLeads2Page />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/leads2/todo" element={
                <ProtectedAdminRoute>
                  <AdminLeads2TodoPage />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/leads2/:id" element={
                <ProtectedAdminRoute>
                  <AdminLead2DetailPage />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/labels" element={
                <ProtectedAdminRoute>
                  <AdminLabels />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/template-canva" element={
                <ProtectedAdminRoute>
                  <AdminCanvaTemplates />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/gallery" element={
                <ProtectedAdminRoute>
                  <AdminGallery />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/settings" element={
                <ProtectedAdminRoute>
                  <AdminSettings />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/formats" element={
                <ProtectedAdminRoute>
                  <AdminFormats />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/discount-tiers" element={
                <ProtectedAdminRoute>
                  <AdminDiscountTiers />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/shipping-costs" element={
                <ProtectedAdminRoute>
                  <AdminShippingCosts />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/coupons" element={
                <ProtectedAdminRoute>
                  <AdminCoupons />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/quotes" element={
                <ProtectedAdminRoute>
                  <AdminQuotes />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/quotes/:id" element={
                <ProtectedAdminRoute>
                  <QuoteDetail />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/orders/:id" element={
                <ProtectedAdminRoute>
                  <OrderDetail />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/customers" element={
                <ProtectedAdminRoute>
                  <AdminCustomers />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/crm/funnel" element={
                <ProtectedAdminRoute>
                  <AdminCrmFunnel />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/crm/templates" element={
                <ProtectedAdminRoute>
                  <AdminCrmTemplates />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/landing-leads" element={
                <ProtectedAdminRoute>
                  <AdminLandingLeads />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/lead-categories" element={
                <ProtectedAdminRoute>
                  <AdminLeadCategories />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/agents" element={
                <ProtectedAdminRoute>
                  <AdminAgents />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/agents/commission-plans" element={
                <ProtectedAdminRoute>
                  <AdminAgents />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/customers/:id" element={
                <ProtectedAdminRoute>
                  <CustomerDetail />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/users" element={
                <ProtectedAdminRoute>
                  <AdminUsers />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/users/:userId" element={
                <ProtectedAdminRoute>
                  <UserDetail />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/products" element={
                <ProtectedAdminRoute>
                  <AdminProducts />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/ingredients" element={
                <ProtectedAdminRoute>
                  <AdminIngredients />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/bottles" element={
                <ProtectedAdminRoute>
                  <AdminBottles />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/newsletter" element={
                <ProtectedAdminRoute>
                  <AdminNewsletter />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/global-discounts" element={
                <ProtectedAdminRoute>
                  <GlobalDiscountSettings />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/collections" element={
                <ProtectedAdminRoute>
                  <AdminCollections />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/blog" element={
                <ProtectedAdminRoute>
                  <AdminBlog />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/digital-services" element={
                <ProtectedAdminRoute>
                  <AdminDigitalServices />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/commissions" element={
                <ProtectedAdminRoute>
                  <AdminCommissions />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/leads/import" element={
                <ProtectedAdminRoute>
                  <AdminLeadsImport />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/payment-methods" element={
                <ProtectedAdminRoute>
                  <AdminPaymentMethods />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/sample-orders" element={
                <ProtectedAdminRoute>
                  <AdminSampleOrders />
                </ProtectedAdminRoute>
              } />
              <Route path="/admin/graphic-requests" element={
                <ProtectedAdminRoute>
                  <AdminGraphicRequests />
                </ProtectedAdminRoute>
              } />

              {/* Portale Agente (auth agent) */}
              <Route path="/agent/login" element={<AgentLogin />} />
              <Route path="/agent/dashboard" element={<AgentDashboard />} />
              <Route path="/agent/customers" element={<AgentCustomers />} />
              <Route path="/agent/quotes" element={<AgentQuotes />} />
              <Route path="/agent/quotes/new" element={<AgentQuoteNew />} />
              <Route path="/agent/quotes/:quoteId/edit" element={<AgentQuoteNew />} />
              <Route path="/agent/orders" element={<AgentOrders />} />
              <Route path="/agent/samples" element={<AgentSamples />} />
              <Route path="/agent/commissions" element={<AgentCommissions />} />
              <Route path="/agent/graphic-requests" element={<AgentGraphicRequests />} />
              <Route path="/agent/leads2" element={<AgentLeads2Page />} />
              <Route path="/agent/leads2/todo" element={<AgentLeads2TodoPage />} />
              <Route path="/agent/leads2/:id" element={<AgentLead2DetailPage />} />              <Route path="/agent/strumenti/listino" element={<AgentListino />} />
              <Route path="/agent/strumenti/calcolatore" element={<AgentProfitCalculator />} />
          </Routes>
          <Toaster />
          
          {/* WhatsApp Float Button - Always visible */}
          <WhatsAppFloat />
          
          {/* Cookie Consent Banner */}
          <CookieConsent />
        </div>
        </AgentAuthProvider>
      </AdminAuthProvider>
    </AuthProvider>
    </HelmetProvider>
  );
}

export default App;